import React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';

const METHODS = ['EFT', 'Cash', 'Other'];

const PaymentMethodSelect = ({ value, onChange, label = 'Payment Method', size = 'medium', required = false, disabled = false, sx }) => (
  <FormControl fullWidth size={size} sx={sx} required={required} disabled={disabled}>
    <InputLabel>{label}</InputLabel>
    <Select
      value={value || 'EFT'}
      onChange={(e) => onChange(e.target.value)}
      label={label}
    >
      {METHODS.map((m) => (
        <MenuItem key={m} value={m}>{m}</MenuItem>
      ))}
    </Select>
  </FormControl>
);

export default PaymentMethodSelect;
export { METHODS };
